// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* === PrizeItem styled components === */
.xH7jlMnxuT4XX8KND18g {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1 0;
  min-width: 0;
}
.KZ4j0kHL5jdiuhC7BeX1 {
  background-color: #101012;
  padding: 8px 4px;
  width: 100%;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-radius: 6px;
  overflow: hidden;
}
.dYhzEZcmx5HVMxCRJp6l {
  padding: 10px 4px 1px;
}
.Z55G_1PIqHxl3g9Uu2G6 {
  background-color: #101012;
  font-weight: 800;
  line-height: 1;
  font-family: var(--font-family-secondary, inherit);
  white-space: nowrap;
}
.sclHlT0lgS_MLwAYR1RZ {
  display: flex;
  align-items: center;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  color: white;
  border-bottom: 0.5px solid rgba(101, 101, 101, 0.3);
  height: 48px;
  padding: 6px 8px;
}
.sclHlT0lgS_MLwAYR1RZ:last-child {
  border-bottom: none;
}
.PXjIazWDsGDzKxIT_JAN {
  padding: 3px 8px;
}
.culTAgQV9lL50G6odsVS {
  font-size: 21px;
  font-weight: 400;
  line-height: 1.1;
  letter-spacing: 0.17px;
  font-family: var(--font-family-primary, inherit);
}
.m_yIU6fwTbmuNbpqvLh3 {
  font-size: 22px;
  font-weight: 800;
  line-height: 1;
  letter-spacing: 0.17px;
  color: var(--campaign-color-text-white);
  font-family: var(--font-family-secondary, inherit);
}
.bx96rAHsbIjeni4IeR8k {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.g0aUG03kAkSgvzHGjQpx {
  padding-right: 5px;
  font-size: 22px;
  align-self: center;
}
.g0aUG03kAkSgvzHGjQpx[prize-type="ITEM"] {
  padding-right: 0;
}
.ZwBmDp4A1XPEvPyverTo {
  font-size: 11px;
  text-transform: uppercase;
  position: relative;
  bottom: 0;
}
.m6kEfSNUMMdFGMVGvk3p {
  font-size: 11px;
  position: relative;
  bottom: 0;
}
.G85twR3bMpQltGG2FqKI {
  color: #C3C3C3;
  font-weight: 500;
}
.G85twR3bMpQltGG2FqKI[data-top-wins="true"] {
  font-size: 13px;
  line-height: 0.7;
}
.G85twR3bMpQltGG2FqKI[data-top-wins="false"] {
  font-size: 15px;
  line-height: normal;
}
@media (max-width: 374px) {
  .KZ4j0kHL5jdiuhC7BeX1 {
    padding: 4px;
  }
  .g0aUG03kAkSgvzHGjQpx {
    font-size: 14px;
  }
  .m6kEfSNUMMdFGMVGvk3p {
    font-size: 11px;
  }
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .sclHlT0lgS_MLwAYR1RZ {
    height: 32px;
  }
  .culTAgQV9lL50G6odsVS {
    font-size: 14px;
    letter-spacing: 0.11px;
  }
  .m_yIU6fwTbmuNbpqvLh3 {
    font-size: 15px;
    letter-spacing: 0.11px;
  }
  .KZ4j0kHL5jdiuhC7BeX1 {
    height: 30px;
  }
  .dYhzEZcmx5HVMxCRJp6l {
    padding: 6px 4px 1px;
  }
  .g0aUG03kAkSgvzHGjQpx[data-top-wins="true"] {
    font-size: 18px;
  }
  .g0aUG03kAkSgvzHGjQpx[data-top-wins="false"] {
    font-size: 15px;
  }
  .G85twR3bMpQltGG2FqKI {
    padding-bottom: 2px;
  }
  .G85twR3bMpQltGG2FqKI[data-top-wins="true"] {
    font-size: 9px;
  }
  .G85twR3bMpQltGG2FqKI[data-top-wins="false"] {
    font-size: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/variants/tournaments/tabs/RewardsTab/PrizeItem/PrizeItem.module.css"],"names":[],"mappings":"AAAA,wCAAwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,kDAAkD;EAClD,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,8BAA8B;EAC9B,YAAY;EACZ,mDAAmD;EACnD,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,gDAAgD;AAClD;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,uCAAuC;EACvC,kDAAkD;AACpD;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,eAAe;IACf,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,sBAAsB;EACxB;EACA;IACE,YAAY;EACd;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* === PrizeItem styled components === */\n.prizeContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 1 1 0;\n  min-width: 0;\n}\n.prizeBox {\n  background-color: #101012;\n  padding: 8px 4px;\n  width: 100%;\n  height: 45px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  border-radius: 6px;\n  overflow: hidden;\n}\n.prizeBoxWithBet {\n  padding: 10px 4px 1px;\n}\n.prizeText {\n  background-color: #101012;\n  font-weight: 800;\n  line-height: 1;\n  font-family: var(--font-family-secondary, inherit);\n  white-space: nowrap;\n}\n.minorPrizeContainer {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  width: 100%;\n  justify-content: space-between;\n  color: white;\n  border-bottom: 0.5px solid rgba(101, 101, 101, 0.3);\n  height: 48px;\n  padding: 6px 8px;\n}\n.minorPrizeContainer:last-child {\n  border-bottom: none;\n}\n.minorPrizeContainerWithBet {\n  padding: 3px 8px;\n}\n.minorPrizePositionText {\n  font-size: 21px;\n  font-weight: 400;\n  line-height: 1.1;\n  letter-spacing: 0.17px;\n  font-family: var(--font-family-primary, inherit);\n}\n.minorPrizeValue {\n  font-size: 22px;\n  font-weight: 800;\n  line-height: 1;\n  letter-spacing: 0.17px;\n  color: var(--campaign-color-text-white);\n  font-family: var(--font-family-secondary, inherit);\n}\n.minorPrizeValueWithBet {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n.prizeTextSpan {\n  padding-right: 5px;\n  font-size: 22px;\n  align-self: center;\n}\n.prizeTextSpan[prize-type=\"ITEM\"] {\n  padding-right: 0;\n}\n.giftSpinText {\n  font-size: 11px;\n  text-transform: uppercase;\n  position: relative;\n  bottom: 0;\n}\n.currencyText {\n  font-size: 11px;\n  position: relative;\n  bottom: 0;\n}\n.giftSpinBetText {\n  color: #C3C3C3;\n  font-weight: 500;\n}\n.giftSpinBetText[data-top-wins=\"true\"] {\n  font-size: 13px;\n  line-height: 0.7;\n}\n.giftSpinBetText[data-top-wins=\"false\"] {\n  font-size: 15px;\n  line-height: normal;\n}\n@media (max-width: 374px) {\n  .prizeBox {\n    padding: 4px;\n  }\n  .prizeTextSpan {\n    font-size: 14px;\n  }\n  .currencyText {\n    font-size: 11px;\n  }\n}\n@media (--campaign-mobile) {\n  .minorPrizeContainer {\n    height: 32px;\n  }\n  .minorPrizePositionText {\n    font-size: 14px;\n    letter-spacing: 0.11px;\n  }\n  .minorPrizeValue {\n    font-size: 15px;\n    letter-spacing: 0.11px;\n  }\n  .prizeBox {\n    height: 30px;\n  }\n  .prizeBoxWithBet {\n    padding: 6px 4px 1px;\n  }\n  .prizeTextSpan[data-top-wins=\"true\"] {\n    font-size: 18px;\n  }\n  .prizeTextSpan[data-top-wins=\"false\"] {\n    font-size: 15px;\n  }\n  .giftSpinBetText {\n    padding-bottom: 2px;\n  }\n  .giftSpinBetText[data-top-wins=\"true\"] {\n    font-size: 9px;\n  }\n  .giftSpinBetText[data-top-wins=\"false\"] {\n    font-size: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"prizeContainer": `xH7jlMnxuT4XX8KND18g`,
	"prizeBox": `KZ4j0kHL5jdiuhC7BeX1`,
	"prizeBoxWithBet": `dYhzEZcmx5HVMxCRJp6l`,
	"prizeText": `Z55G_1PIqHxl3g9Uu2G6`,
	"minorPrizeContainer": `sclHlT0lgS_MLwAYR1RZ`,
	"minorPrizeContainerWithBet": `PXjIazWDsGDzKxIT_JAN`,
	"minorPrizePositionText": `culTAgQV9lL50G6odsVS`,
	"minorPrizeValue": `m_yIU6fwTbmuNbpqvLh3`,
	"minorPrizeValueWithBet": `bx96rAHsbIjeni4IeR8k`,
	"prizeTextSpan": `g0aUG03kAkSgvzHGjQpx`,
	"giftSpinText": `ZwBmDp4A1XPEvPyverTo`,
	"currencyText": `m6kEfSNUMMdFGMVGvk3p`,
	"giftSpinBetText": `G85twR3bMpQltGG2FqKI`
};
export default ___CSS_LOADER_EXPORT___;
